import { render, staticRenderFns } from "./CfoMenu.vue?vue&type=template&id=0072d3e6"
import script from "./CfoMenu.vue?vue&type=script&lang=js"
export * from "./CfoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports